<template>
  <div class="RwvTags">
    <b-badge
      pill
      variant="success"
      v-for="(tag, index) in tags"
      :key="index">
      {{ tag }}
    </b-badge>
  </div>
</template>

<script>
export default {
  name: "RwvTags",
  props: {
    tags: {
      type: Array,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
